__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ta-tax-center-fe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@mui/system", "5.17.1", () => (Promise.all([__webpack_require__.e(184), __webpack_require__.e(466), __webpack_require__.e(710), __webpack_require__.e(153)]).then(() => (() => (__webpack_require__(466))))));
			register("@securitize/domain", "2.47.0", () => (Promise.all([__webpack_require__.e(280), __webpack_require__.e(495)]).then(() => (() => (__webpack_require__(745))))));
			register("@securitize/reactjs-whm", "1.27.0", () => (Promise.all([__webpack_require__.e(184), __webpack_require__.e(633), __webpack_require__.e(970), __webpack_require__.e(710), __webpack_require__.e(334), __webpack_require__.e(56), __webpack_require__.e(934), __webpack_require__.e(534)]).then(() => (() => (__webpack_require__(2633))))));
			register("@tanstack/react-query", "5.67.1", () => (Promise.all([__webpack_require__.e(172), __webpack_require__.e(710), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(8172))))));
			register("axios", "1.8.1", () => (__webpack_require__.e(344).then(() => (() => (__webpack_require__(4344))))));
			register("dompurify", "3.2.5", () => (__webpack_require__.e(977).then(() => (() => (__webpack_require__(7977))))));
			register("formik", "2.4.6", () => (Promise.all([__webpack_require__.e(516), __webpack_require__.e(710), __webpack_require__.e(219)]).then(() => (() => (__webpack_require__(3516))))));
			register("html-react-parser", "5.2.3", () => (Promise.all([__webpack_require__.e(229), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(229))))));
			register("js-cookie", "3.0.5", () => (__webpack_require__.e(880).then(() => (() => (__webpack_require__(1880))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(6178))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "6.30.0", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(475), __webpack_require__.e(710), __webpack_require__.e(334), __webpack_require__.e(61)]).then(() => (() => (__webpack_require__(5475))))));
			register("react-router", "6.30.0", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(216), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(3216))))));
			register("react-transition-group", "4.4.5", () => (Promise.all([__webpack_require__.e(330), __webpack_require__.e(710), __webpack_require__.e(334), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__(3330))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("superagent", "10.1.1", () => (Promise.all([__webpack_require__.e(797), __webpack_require__.e(634)]).then(() => (() => (__webpack_require__(6797))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(6453))))));
			register("yup", "1.6.1", () => (__webpack_require__.e(899).then(() => (() => (__webpack_require__(899))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};